// Export the main tracking function
export function initializeTracker() {
    const SERVER_URL = 'revenue-node-server.vercel.app';

// Function to get a cookie by name
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Function to set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    const hostname = window.location.hostname;
    
    // Handle localhost and IP addresses
    if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
        return;
    }
    
    const parts = hostname.split('.');
    
    // For country-code TLDs (e.g., .co.uk, .com.au), take last 3 parts
    // For regular TLDs (e.g., .com, .org), take last 2 parts
    const twoLevelTLDs = ['co.uk', 'com.au', 'co.nz', 'co.za', 'com.br', 'co.jp'];
    const lastTwo = parts.slice(-2).join('.');
    const lastThree = parts.slice(-3).join('.');
    
    let domain;
    if (twoLevelTLDs.includes(lastTwo)) {
        domain = '.' + lastThree;
    } else {
        domain = '.' + lastTwo;
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + domain + "; SameSite=Lax";
}

// sessionStorage throws when storage is blocked, which is the same situation
// where cookies fail, so every access has to tolerate it being unavailable
function getSessionItem(key) {
    try {
        return sessionStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

function setSessionItem(key, value) {
    try {
        sessionStorage.setItem(key, value);
    } catch (e) {
        console.log('Session storage unavailable, cannot persist', key);
    }
}

// Function to get a meta tag content by name
function isSetupCheck() {
    try {
        return new URLSearchParams(window.location.search).get('rtverify') === '1';
    } catch (e) {
        return false;
    }
}
function trackingHost(fallback) {
    if (!isSetupCheck()) return fallback;
    try {
        const host = new URLSearchParams(window.location.search).get('rthost');
        const allowedHost = host === 'revenue-node-server.vercel.app'
            || /^revenue-node-server-[a-z0-9]+-tuomaskiviojas-projects\.vercel\.app$/.test(host || '');
        return allowedHost ? host : fallback;
    } catch (e) {
        return fallback;
    }
}


function setupBannerStyle(mode) {
    const success = mode === 'success';
    const failure = mode === 'failure';
    return [
        'position:fixed',
        'bottom:24px',
        'left:50%',
        'transform:translateX(-50%)',
        'z-index:2147483647',
        'display:flex',
        failure ? 'flex-direction:column' : 'flex-direction:row',
        failure ? 'align-items:stretch' : 'align-items:center',
        'gap:14px',
        'box-sizing:border-box',
        'min-width:min(460px, calc(100% - 32px))',
        'max-width:calc(100% - 32px)',
        'padding:22px 28px',
        'background:#021220',
        'color:#f3f4f6',
        success ? 'border:2px solid #00F2A5' : failure ? 'border:2px solid #f87171' : 'border:2px solid #00D3F2',
        'border-radius:16px',
        'font:600 18px/1.35 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif',
        success
            ? 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(0,242,165,.15)'
            : failure
            ? 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(248,113,113,.16)'
            : 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(0,211,242,.18)'
    ].join(';');
}

function ensureSetupBannerAnimation() {
    if (document.getElementById('revtrack-setup-banner-style')) return;
    const style = document.createElement('style');
    style.id = 'revtrack-setup-banner-style';
    style.textContent = '@keyframes revtrack-setup-spin{to{transform:rotate(360deg)}}';
    (document.head || document.documentElement).appendChild(style);
}

function ensureSetupCheckBanner() {
    if (!isSetupCheck()) return null;
    const existing = document.getElementById('revtrack-setup-banner');
    if (existing) return existing;
    ensureSetupBannerAnimation();
    const el = document.createElement('div');
    el.id = 'revtrack-setup-banner';
    el.setAttribute('style', setupBannerStyle('checking'));
    const spinner = document.createElement('span');
    spinner.setAttribute('style', [
        'width:22px',
        'height:22px',
        'flex:none',
        'border-radius:50%',
        'border:3px solid rgba(0,211,242,.25)',
        'border-top-color:#00D3F2',
        'animation:revtrack-setup-spin .8s linear infinite'
    ].join(';'));
    const label = document.createElement('span');
    label.textContent = 'Checking for script...';
    el.appendChild(spinner);
    el.appendChild(label);
    const mount = () => {
        if (document.body && !document.getElementById('revtrack-setup-banner')) {
            document.body.appendChild(el);
        }
    };
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
    return el;
}

function showSetupCheckSuccess() {
    if (!getOfferTagStatus().ok) {
        showSetupCheckFailure(true);
        return;
    }
    pingSetupCheck('success');
    const el = ensureSetupCheckBanner();
    if (!el) return;
    el.setAttribute('style', setupBannerStyle('success'));
    el.textContent = '';
    const box = document.createElement('span');
    box.setAttribute('style', [
        'width:28px',
        'height:28px',
        'flex:none',
        'border-radius:7px',
        'background:#00F2A5',
        'display:flex',
        'align-items:center',
        'justify-content:center'
    ].join(';'));
    box.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.2l3 3.1 6-6.6" stroke="#021220" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const label = document.createElement('span');
    label.textContent = 'Test click recorded - your script is working';
    el.appendChild(box);
    el.appendChild(label);
}

function setupCheckMark(ok) {
    const mark = document.createElement('span');
    mark.setAttribute('style', [
        'width:22px',
        'height:22px',
        'flex:none',
        'border-radius:6px',
        'display:flex',
        'align-items:center',
        'justify-content:center',
        ok ? 'background:#00F2A5' : 'background:#f87171'
    ].join(';'));
    mark.innerHTML = ok
        ? '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.2l3 3.1 6-6.6" stroke="#021220" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="#021220" stroke-width="2.2" stroke-linecap="round"/></svg>';
    return mark;
}

function getOfferTagStatus() {
    const offer = getMetaContentByName('offer');
    const hasOffer = !!(offer && String(offer).trim());
    if (!hasOffer) return { ok: false, detail: 'Missing' };
    let expected = '';
    try {
        expected = new URLSearchParams(window.location.search).get('utm_offer') || '';
    } catch (e) {
        expected = '';
    }
    if (expected && offer.trim() !== expected.trim()) {
        return { ok: false, detail: 'Does not match this offer' };
    }
    return { ok: true, detail: 'Found' };
}

function showSetupCheckFailure(clickTracked) {
    const el = ensureSetupCheckBanner();
    if (!el) return;
    const username = getMetaContentByName('username');
    const hasUsername = !!(username && String(username).trim());
    const offerStatus = getOfferTagStatus();
    const rows = [
        { ok: offerStatus.ok, label: 'Offer tag', detail: offerStatus.detail },
        { ok: hasUsername, label: 'Username tag', detail: hasUsername ? 'Found' : 'Missing' },
        { ok: true, label: 'Script', detail: 'Found' }
    ];
    if (clickTracked) {
        rows.push({ ok: true, label: 'Click tracked', detail: 'Recorded' });
    }
    el.setAttribute('style', setupBannerStyle('failure'));
    el.textContent = '';
    rows.forEach((row) => {
        const line = document.createElement('div');
        line.setAttribute('style', 'display:flex;align-items:center;gap:12px;');
        const copy = document.createElement('span');
        copy.setAttribute('style', 'font:600 16px/1.35 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;');
        copy.textContent = row.label + ' — ' + row.detail;
        line.appendChild(setupCheckMark(row.ok));
        line.appendChild(copy);
        el.appendChild(line);
    });
    const note = document.createElement('p');
    note.setAttribute('style', 'margin:8px 0 0;font:400 13px/1.45 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;color:#949BB8;');
    note.textContent = 'Ensure you have pasted the exact script from your offer. If you still see this error, see if there is another way to paste code in your website editor as sometimes only one method works. If you still see this, do not worry, please reach out to support at hi@getrevtrack.com and we will help you troubleshoot this.';
    el.appendChild(note);
}

function getMetaContentByName(name) {
    const metaTag = document.querySelector(`meta[name="${name}"]`);
    return metaTag ? metaTag.getAttribute('content') : null;
}

// Function to get the "video" or "email" parameter from the URL and return the resourceClicked object
function getResourceClicked() {
    const params = new URLSearchParams(window.location.search);

    // Check if the 'video' or 'email' parameter exists
    if (params.has('video')) {
        const videoName = params.get('video');
        if (videoName.endsWith('...')) {
            console.log("Video id broken, not tracking");
            return { type: 'NA', name: 'NA' };
        }
        return { type: 'video', name: videoName };
    } else if (params.has('rtemail')) {
        return { type: 'email', name: params.get('rtemail') };
    } else if (params.has('community')) {
        return { type: 'community', name: params.get('community') };
    } else if (params.has('channel')) {
        return { type: 'channel', name: params.get('channel') };
    } else if (params.has('twitter')) {
        return { type: 'twitter', name: params.get('twitter') };
    } else if (params.has('instagram')) {
        return { type: 'instagram', name: params.get('instagram') };
    } else if (params.has('threads')) {
        return { type: 'threads', name: params.get('threads') };
    } else if (params.has('linkedin')) {
        return { type: 'linkedin', name: params.get('linkedin') };
    } else if (params.has('podcast')) {
        return { type: 'podcast', name: params.get('podcast') };
    } else if (params.has('blog')) {
        return { type: 'blog', name: params.get('blog') };
    } else if (params.has('website')) {
        return { type: 'website', name: params.get('website') };
    } else if (params.has('tiktok')) {
        return { type: 'tiktok', name: params.get('tiktok') };
    } else if (params.has('ad')) {
        return { type: 'ad', name: params.get('ad') };
    } else if (params.has('telegram')) {
        return { type: 'telegram', name: params.get('telegram') };
    } else if (params.has('facebook')) {
        return { type: 'facebook', name: params.get('facebook') };
    } else if (params.has('discord')) {
        return { type: 'discord', name: params.get('discord') };
    } else if (params.has('pinComment')) {
        return { type: 'pinComment', name: params.get('pinComment') };
    } else if (params.has('live')) {
        return { type: 'live', name: params.get('live') };
    } else if (params.has('webinar')) {
        return { type: 'webinar', name: params.get('webinar') };
    } else if (params.has('leadMagnet')) {
        return { type: 'leadMagnet', name: params.get('leadMagnet') };
    } else if (params.has('qr')) {
        return { type: 'qr', name: params.get('qr') };
    } else {
        console.log("No resource parameter found in URL");
        return { type: 'NA', name: 'NA' };
    }
}

function hasValidResource(resourceClicked) {
    return !!(
        resourceClicked
        && resourceClicked.name
        && resourceClicked.type
        && resourceClicked.name !== 'NA'
        && resourceClicked.type !== 'NA'
        && String(resourceClicked.name).trim() !== ''
        && String(resourceClicked.type).trim() !== ''
    );
}

function getClickTrackKey(resourceClicked) {
    return hasValidResource(resourceClicked)
        ? `resourceClick_${resourceClicked.name}`
        : 'resourceClick__no_resource';
}

// Function to send resource click event to the server
async function sendResourceClickToServer(resourceClicked, userInfo, customerUsername) {
    const username = userInfo ? userInfo.username : customerUsername;
    if (!username) {
        console.log("No username available, cannot send resource click");
        showSetupCheckFailure();
        return;
    }

    const offerName = getMetaContentByName('offer');
    if (!offerName || !String(offerName).trim()) {
        console.log("No offer meta tag available, cannot send resource click");
        showSetupCheckFailure();
        return;
    }

    const params = new URLSearchParams(window.location.search);
    const splitTest = params.get('split');
    const withResource = hasValidResource(resourceClicked);

    // Get IP address and click context. These are always included on the click
    // payload, whether or not a resource URL param is present.
    const ipAddress = await getIpAddress();
    const clickContext = getClickContext();

    const payload = {
        username: username,
        offer: offerName,
        referrer: clickContext.referrer,
        device: clickContext.device,
        visit_number: clickContext.visit_number,
        language: clickContext.language,
        page_url: window.location.href
    };

    if (ipAddress) {
        payload.ip_address = ipAddress;
    } else {
        console.log('No IP from ipify; server will use the request IP for this click');
    }

    if (withResource) {
        payload.resourceClicked = resourceClicked;
    }

    // Without a cookie there is no stored lead_id, so the server stitches the
    // click to a lead by IP address instead
    if (userInfo && userInfo.lead_id) {
        payload.lead_id = userInfo.lead_id;
    }

    // Add split test variant if it exists
    if (splitTest) {
        payload.splitTest = splitTest;
        console.log("Split test variant found:", splitTest);
    }

    if (isSetupCheck()) payload.isTest = true;
    console.log("Sending resource click payload:", payload);

    // Send the POST request to the server to track the resource click
    fetch(`https://${trackingHost(SERVER_URL)}/api/resource-click/${username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
    .then(response => response.json().then(data => ({ ok: response.ok, data })))
    .then(({ ok, data }) => {
        console.log('Response from server:', data);
        if (ok && data && data.message === 'Click recorded successfully') {
            const trackKey = getClickTrackKey(resourceClicked);
            setSessionItem(trackKey, 'true');
            console.log(`Resource click marked as tracked in session storage (${trackKey})`);
            showSetupCheckSuccess();
        } else {
            showSetupCheckFailure();
        }
    })
    .catch(error => {
        console.error('Error sending resource click info:', error);
        showSetupCheckFailure();
    });
}

// Check if the resource click has already been sent
function isResourceClickAlreadyTracked(resourceClicked) {
    return getSessionItem(getClickTrackKey(resourceClicked)) === 'true';
}

// Function to validate email format
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Function to send email to server and update cookie
function sendEmailToServer(email) {
    console.log('Sending email to server:', email);
    const userInfoCookie = getCookie('userInfo');
    if (!userInfoCookie) {
        console.log("No userInfo cookie found, cannot send email");
        return;
    }

    const userInfo = JSON.parse(userInfoCookie);

    // Update the userInfo object with the email in an array
    if (!userInfo.emails) {
        userInfo.emails = [email]; // Initialize emails array if it doesn't exist
    } else if (!userInfo.emails.includes(email)) {
        userInfo.emails.push(email); // Add email to array if not already present
    } else {
        console.log(`Email ${email} already in userInfo.emails array, not adding again`);
        return; // Skip if email already exists in the array
    }
    
    // Update the cookie immediately
    setCookie('userInfo', JSON.stringify(userInfo), 365);

    const payload = {
        email: email,
        lead_id: userInfo.lead_id,
    };
    console.log("Email capture payload:", payload);

    fetch(`https://${SERVER_URL}/api/email-capture/${userInfo.username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
    .then(response => response.json())
    .then(data => {
        console.log('Email capture response from server:', data);
    })
    .catch(error => {
        console.error('Error sending email info:', error);
    });
}

// Function to handle email input changes
function handleEmailInput(email) {
    if (isValidEmail(email)) {
        // Get current userInfo from cookie
        const userInfoCookie = getCookie('userInfo');
        if (!userInfoCookie) return;

        const userInfo = JSON.parse(userInfoCookie);
        
        // Check if this is a new email not already in the emails array
        const isNewEmail = !userInfo.emails || !userInfo.emails.includes(email);
        
        if (isNewEmail) {
            console.log(`New email detected: ${email}, not in current emails array:`, userInfo.emails || []);
            sendEmailToServer(email);
            console.log('Email captured and stored:', email);
        } else {
            console.log(`Email ${email} already stored in emails array, no update needed`);
        }
    } else {
        console.log(`Invalid email format: ${email}`);
    }
}

// Function to set up email tracking
function setupEmailTracking() {
    // Function to set up tracking for a single input
    function setupInputTracking(input) {
        const isEmailField = 
            input.type === 'email' || 
            input.id.toLowerCase().includes('email') ||
            input.name.toLowerCase().includes('email') ||
            input.placeholder.toLowerCase().includes('email');

        if (isEmailField && !input.hasAttribute('data-email-tracking-setup')) {
            console.log(`Setting up email tracking for input: ${input.id || input.name}`);
            
            // Mark this input as already set up
            input.setAttribute('data-email-tracking-setup', 'true');

            // Listen for blur event (when user leaves the field)
            input.addEventListener('blur', (event) => {
                console.log('Email input blur event triggered');
                const email = event.target.value.trim();
                handleEmailInput(email);
            });

            // Listen for form submission if input is within a form
            const form = input.closest('form');
            if (form && !form.hasAttribute('data-email-tracking-setup')) {
                form.setAttribute('data-email-tracking-setup', 'true');
                form.addEventListener('submit', (event) => {
                    const email = input.value.trim();
                    handleEmailInput(email);
                });
            }
        }
    }

    // Initial setup for existing inputs
    document.querySelectorAll('input').forEach(setupInputTracking);

    // Create an observer instance to watch for new inputs
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Check for added nodes
            mutation.addedNodes.forEach((node) => {
                // Check if the node is an element
                if (node.nodeType === 1) {
                    // If it's an input element, check it directly
                    if (node.tagName === 'INPUT') {
                        setupInputTracking(node);
                    }
                    // If it's another element, check its children for inputs
                    else {
                        node.querySelectorAll('input').forEach(setupInputTracking);
                    }
                }
            });
        });
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Function to generate a unique lead ID
function generateLeadId() {
    return 'lead_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

// Function to detect if Cookiebot has granted consent
function isCookiebotConsentGranted() {
    // 1) Preferred: use the Cookiebot API
    if (typeof window.Cookiebot !== 'undefined' && window.Cookiebot.consent) {
      return !!(window.Cookiebot.consent.marketing || window.Cookiebot.consent.statistics);
    }
  
    // 2) Fallback: read Cookiebot cookie directly
    const rawConsent = getCookie('CookieConsent');
    if (rawConsent) {
      try {
        // Decode first
        const decoded = decodeURIComponent(rawConsent);
  
        // Check for marketing/statistics granted
        return (
          decoded.includes('"marketing":true') ||
          decoded.includes('marketing:true') ||    // older format
          decoded.includes('"statistics":true') ||
          decoded.includes('statistics:true')
        );
      } catch (e) {
        console.warn("Error decoding CookieConsent cookie", e);
        return false;
      }
    }
  
    return true;
  }


// Function to detect if CookieYes has granted consent
function isCookieYesConsentGranted() {
  // 1) Preferred: CookieYes getCkyConsent() API if available
  if (typeof window.getCkyConsent === 'function') {
    try {
      const c = window.getCkyConsent();
      // c might be {analytics: true/"yes", advertisement: true/"yes", ...}
      const a = c && (c.categories.analytics === true || c.categories.analytics === 'yes');
      const ad = c && (c.categories.advertisement === true || c.categories.advertisement === 'yes');
      if (!a && !ad) return false;
      else return true;
    } catch (e) {
      // fall through to other checks
    }
  }

  // 1b) Alternate CookieYes API (older): ckyAPI.getConsentStatus
  if (typeof window.ckyAPI !== 'undefined' && typeof window.ckyAPI.getConsentStatus === 'function') {
    const analytics = window.ckyAPI.getConsentStatus('analytics');
    const ads = window.ckyAPI.getConsentStatus('advertisement');
    return (analytics === 'yes' || ads === 'yes');
  }

  // 2) Fallback: cookieyes-consent (string like "necessary:yes,analytics:no,...")
  const cyConsent = getCookie('cookieyes-consent');
  if (cyConsent) {
    try {
      const map = {};
      cyConsent.split(',').forEach(kv => {
        const [k, v] = kv.split(':');
        if (k && v) map[k.trim()] = v.trim();
      });
      if (map.analytics === 'yes' || map.advertisement === 'yes') return true;
    } catch(e){}
  }

  // 3) Alternative: cky-consent (JSON or string)
  const ckyConsent = getCookie('cky-consent');
  if (ckyConsent) {
    try {
      const parsed = JSON.parse(ckyConsent);
      if (parsed.analytics === true || parsed.analytics === 'yes' ||
          parsed.advertisement === true || parsed.advertisement === 'yes') return true;
    } catch(e) {
      // fallback: string search
      if ((ckyConsent.includes('analytics') && ckyConsent.includes('yes')) ||
          (ckyConsent.includes('advertisement') && ckyConsent.includes('yes'))) {
        return true;
      }
    }
  }

  // Default: not granted (keeping existing behavior of permissive default)
  return true;
}

// Function to detect if CookieScript has granted consent
function isCookieScriptConsentGranted() {
  // 1) Preferred: CookieScript global object (varies by setup)
  try {
    if (typeof window.CookieScript !== 'undefined') {
      const state = window.CookieScript.instance.currentState();
      if (state && state.categories) {
        if (state.categories.includes('targeting') || state.categories.includes('performance') || state.categories.includes('unclassified') || state.categories.includes('functionality')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  } catch(e) { /* ignore */ }
  // Default: granted
  return true;
}

// Function to check if any supported consent platform has granted consent
function isConsentGranted() {
    console.log(isCookiebotConsentGranted(), isCookieYesConsentGranted(), isCookieScriptConsentGranted());
    return isCookiebotConsentGranted() && isCookieYesConsentGranted() && isCookieScriptConsentGranted();
}

// Function to test if cookies can be set
function canSetCookies() {
    const testCookieName = 'revtrack_test_cookie';
    setCookie(testCookieName, 'test', 1);
    const canSet = getCookie(testCookieName) === 'test';
    
    // Clean up test cookie
    if (canSet) {
        document.cookie = testCookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
    
    return canSet;
}

// Function to initialize or get userInfo cookie
function initializeUserInfo(customerUsername) {
    let userInfoCookie = getCookie('userInfo');
    
    if (userInfoCookie) {
        let userInfo = JSON.parse(userInfoCookie);
        // Add lead_id if it doesn't exist in existing cookie
        if (!userInfo.lead_id) {
            userInfo.lead_id = generateLeadId();
            setCookie('userInfo', JSON.stringify(userInfo), 365);
        }
        // Ensure emails is an array
        if (userInfo.email && !userInfo.emails) {
            // Migrate from old format (single email) to new format (emails array)
            userInfo.emails = [userInfo.email];
            delete userInfo.email; // Remove the old single email property
            setCookie('userInfo', JSON.stringify(userInfo), 365);
        } else if (!userInfo.emails) {
            userInfo.emails = [];
            setCookie('userInfo', JSON.stringify(userInfo), 365);
        }
        return userInfo;
    } else {
        // Create new userInfo with lead_id and empty emails array
        const userInfo = {
            username: customerUsername,
            lead_id: generateLeadId(),
            emails: [],
            purchases: {}
        };
        setCookie('userInfo', JSON.stringify(userInfo), 365);
        return userInfo;
    }
}

// Function to handle the tracking logic (can be called multiple times)
function handleTracking(customerUsername, resourceClicked) {
    if (!customerUsername) {
        console.log('No username available, cannot track');
        showSetupCheckFailure();
        return false;
    }

    const offerName = getMetaContentByName('offer');
    if (!offerName || !String(offerName).trim()) {
        console.log('No offer meta tag available, cannot track');
        showSetupCheckFailure();
        return false;
    }

    // Always store latest tracking payload for potential async consent handlers
    setSessionItem('pendingTrackingData', JSON.stringify({
        customerUsername: customerUsername,
        resourceClicked: resourceClicked,
        timestamp: Date.now()
    }));

    // Check if consent is granted
    if (!isConsentGranted()) {
        console.log('Non-essential cookie consent not granted, storing data for later');
        return false; // Indicate that tracking was not completed
    }

    // Consent is granted but the browser is refusing cookies, so the click is still
    // recorded and the server links it to a lead by IP address
    if (!canSetCookies()) {
        console.log('Cookies cannot be set, sending resource click without a lead cookie');

        if (isResourceClickAlreadyTracked(resourceClicked)) {
            console.log('Resource click already tracked this session, skipping');
            showSetupCheckSuccess();
            return true;
        }

        sendResourceClickToServer(resourceClicked, null, customerUsername);
        return true;
    }

    // Initialize userInfo with lead_id
    const userInfo = initializeUserInfo(customerUsername);

    if (hasValidResource(resourceClicked)) {
        userInfo.resourceClicked = resourceClicked;
    }

    if (!userInfo.initial_referrer) {
        const initialReferrer = getInitialReferrer();
        if (initialReferrer) {
            userInfo.initial_referrer = initialReferrer;
        }
    }

    // Check for split test variant from URL parameter and store it
    const params = new URLSearchParams(window.location.search);
    const splitTest = params.get('split');
    if (splitTest) {
        userInfo.splitTest = splitTest;
        console.log("Split test variant stored in userInfo:", splitTest);
    }

    setCookie('userInfo', JSON.stringify(userInfo), 365);

    // Check if the click has already been tracked for this resource
    if (isResourceClickAlreadyTracked(resourceClicked)) {
        console.log('Resource click already tracked this session, skipping');
        showSetupCheckSuccess();
        return true; // Already tracked
    }

    // Send the resource click event to the server
    sendResourceClickToServer(resourceClicked, userInfo, customerUsername);
    
    return true; // Tracking completed
}

// Add email tracking setup to the DOMContentLoaded event
function pingSetupCheck(status) {
    if (!isSetupCheck()) return;
    let params;
    try {
        params = new URLSearchParams(window.location.search);
    } catch (e) {
        return;
    }
    const username = getMetaContentByName('username') || params.get('rtuser');
    if (!username) return;
    const offer = getMetaContentByName('offer') || params.get('utm_offer') || '';
    const step = params.get('rtstep') || '';
    const host = params.get('rthost');
    const allowedHost = host === 'revenue-node-server.vercel.app'
        || /^revenue-node-server-[a-z0-9]+-tuomaskiviojas-projects\.vercel\.app$/.test(host || '');
    const pingHost = allowedHost ? host : SERVER_URL;
    fetch(`https://${pingHost}/api/setup-check-ping/${encodeURIComponent(username)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ offer, step, status: status === 'success' ? 'success' : 'loaded' })
    }).catch(() => {});
}

// Core tracking setup — extracted so it can be called immediately when the DOM
// is already ready (React SPA), or deferred via DOMContentLoaded on first load.
function runTrackingSetup() {
    pingSetupCheck();
    ensureSetupCheckBanner();
    const customerUsername = getMetaContentByName('username');
    if (!customerUsername) {
        showSetupCheckFailure();
        return;
    }

    // Set up email tracking
    setupEmailTracking();

    const resourceClicked = getResourceClicked();
    console.log("Resource clicked:", resourceClicked);

    // Try to handle tracking immediately (resource is optional; username + offer are required)
    const trackingCompleted = handleTracking(customerUsername, resourceClicked);

    // If tracking wasn't completed (consent not granted), rely on CMP events to resume tracking
    if (!trackingCompleted) {
        console.log('Initial tracking failed; awaiting consent events to resume tracking');
    }
}

// In a React SPA, DOMContentLoaded has already fired by the time useEffect
// calls initializeTracker(), so run immediately in that case.
if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', runTrackingSetup);
} else {
    runTrackingSetup();
}

document.addEventListener("cookieyes_consent_update", function (eventData) 
{   
    console.log("CookieYes consent updated:", eventData);
    const customerUsername = getMetaContentByName('username');
    const resourceClicked = getResourceClicked();
    handleTracking(customerUsername, resourceClicked);
    // Check the value in the JSON eventData and perform desired action
});

// Handle Cookiebot consent acceptance
document.addEventListener('CookiebotOnAccept', function () {
    console.log("Cookiebot consent updated");
    try {
        // Prefer using the pending payload we always store
        const pending = sessionStorage.getItem('pendingTrackingData');
        if (pending) {
            const { customerUsername, resourceClicked } = JSON.parse(pending);
            handleTracking(customerUsername, resourceClicked);
            return;
        }
    } catch (e) {
        // Fallback to recomputing if parsing fails
    }

    // Fallback: recompute from DOM/URL
    const customerUsername = getMetaContentByName('username');
    const resourceClicked = getResourceClicked();
    handleTracking(customerUsername, resourceClicked);
});

// Handle OneTrust consent updates (support common event casings)
function triggerTrackingFromPendingOrContext() {
    console.log("Cookies consent updated");
    try {
        const pending = sessionStorage.getItem('pendingTrackingData');
        if (pending) {
            const { customerUsername, resourceClicked } = JSON.parse(pending);
            handleTracking(customerUsername, resourceClicked);
            return;
        }
    } catch (e) {
        // ignore and fallback
    }
    const customerUsername = getMetaContentByName('username');
    const resourceClicked = getResourceClicked();
    handleTracking(customerUsername, resourceClicked);
}

// Capitalized event name used by many OneTrust setups
document.addEventListener('OneTrustGroupsUpdated', triggerTrackingFromPendingOrContext);
// Lowercase variant in case of custom dispatch
// CookieScript consent events
document.addEventListener('CookieScriptAccept', triggerTrackingFromPendingOrContext);
document.addEventListener('CookieScriptAcceptAll', triggerTrackingFromPendingOrContext);
// Some CookieScript setups may dispatch lowercase/custom event names

// Function to get IP address
async function getIpAddress() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2500);
    try {
        const response = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
        const data = await response.json();
        const ip = typeof data?.ip === 'string' ? data.ip.trim() : '';
        return ip || null;
    } catch (error) {
        console.error('Error fetching IP:', error);
        return null;
    } finally {
        clearTimeout(timer);
    }
}

function getDeviceType() {
    const ua = navigator.userAgent || '';
    const hints = navigator.userAgentData;
    if (hints && hints.mobile === true) {
        return 'mobile';
    }
    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) return 'tablet';
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'mobile';
    return 'desktop';
}

function getVisitNumber() {
    const key = `revtrack_visits:${window.location.pathname}`;
    try {
        const current = parseInt(localStorage.getItem(key) || '0', 10);
        const next = (Number.isFinite(current) && current > 0 ? current : 0) + 1;
        localStorage.setItem(key, String(next));
        return next;
    } catch (e) {
        return 1;
    }
}

function getClickContext() {
    const language = navigator.language || (navigator.languages && navigator.languages[0]) || null;
    return {
        referrer: document.referrer || null,
        device: getDeviceType(),
        visit_number: getVisitNumber(),
        language: language || null
    };
}

function getInitialReferrer() {
    const referrer = typeof document.referrer === 'string' ? document.referrer.trim() : '';
    return referrer ? referrer.slice(0, 2000) : null;
}


}
